<mat-dialog-content>
  <ng-container>
    <div class="modal-header">
      <h2 matDialogTitle>
        {{
          'FRONTEND.SALES_UI.SALES_OPPORTUNITIES.REOPENING_OPPORTUNITIES.REOPEN_OPPORTUNITY_ACTION'
            | translate : { opportunityName: opportunityInfo.opportunityName }
        }}
      </h2>
      <span class="icon icon-remove modal-close" (click)="dialogRef.close()"></span>
    </div>
    <p class="dialog-message">
      {{ 'FRONTEND.SALES_UI.SALES_OPPORTUNITIES.REOPENING_OPPORTUNITIES.OPPORTUNITY_REOPEN_DETAILS' | translate }}
    </p>
    <mat-form-field>
      <input
        matInput
        [formControl]="reason"
        placeholder="{{
          'FRONTEND.SALES_UI.SALES_OPPORTUNITIES.REOPENING_OPPORTUNITIES.OPPORTUNITY_REOPEN_REASON' | translate
        }}"
        required
      />
      <mat-error *ngIf="reason.invalid">{{ getErrorMessage() }}</mat-error>
    </mat-form-field>
    <mat-dialog-actions>
      <button mat-raised-button color="primary" (click)="onSubmit()">
        {{ 'FRONTEND.SALES_UI.SALES_OPPORTUNITIES.REOPEN' | translate }}
      </button>
      <button mat-button color="primary" mat-dialog-close>
        {{ 'FRONTEND.SALES_UI.CANCEL' | translate }}
      </button>
    </mat-dialog-actions>
  </ng-container>
</mat-dialog-content>
